import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 7,
	viewBox: "0 0 11 7",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1 1L5.5 5L10 1",
		stroke: "black",
		strokeWidth: 1.5
	})
});
export default SvgArrowDown;
